import Facebook from 'components/icons/Facebook';

export const socialLinks = [
  {
    icon: <Facebook />,
    id: 'facebook',
    href: 'https://www.facebook.com/pbstart/',
  },
];
